// Área "pix" — fluxo de transferência PIX (formulário, confirmação, comprovante,
// indicador de passos e modal de erro). Cobertura de 4 idiomas. Ver src/i18n/index.jsx.
// Fallback: idioma ausente cai para pt e, se faltar, para a própria chave.
const pix = {
  pt: {
    // Comuns ao fluxo
    'pix.transfer_pix': 'Transferência PIX',
    'pix.available_balance': 'Saldo disponível',
    'pix.key_label': 'Chave PIX',
    'pix.recipient': 'Destinatário',
    'pix.bank': 'Banco',
    'pix.amount_label': 'Valor',
    'pix.description': 'Descrição',
    'pix.description_optional': 'Descrição (opcional)',
    'pix.date_time': 'Data e hora',
    'pix.processing': 'Processando...',
    'pix.continue': 'Continuar',
    'pix.back': 'Voltar',
    'pix.not_identified': 'Não identificado',
    'pix.insufficient_balance': 'Saldo insuficiente',
    'pix.receipt': 'Comprovante',
    // PixTransferForm
    'pix.load_account_error': 'Não foi possível carregar os dados da sua conta.',
    'pix.enter_valid_key': 'Digite uma chave PIX válida',
    'pix.invalid_key': 'Chave PIX inválida',
    'pix.validate_key_error': 'Erro ao validar a chave PIX.',
    'pix.invalid_amount': 'Valor inválido',
    'pix.transfer_success': 'Transferência realizada com sucesso!',
    'pix.process_error': 'Erro ao processar sua transferência.',
    // PixConfirmation
    'pix.validate_transaction_error': 'Erro ao validar a transação PIX.',
    'pix.process_error_retry': 'Ocorreu um erro ao processar sua transferência. Tente novamente mais tarde.',
    'pix.transfer_completed': 'Transferência via PIX concluída',
    'pix.insufficient_data': 'Dados insuficientes para confirmar a transferência.',
    'pix.back_to_form': 'Voltar ao formulário',
    'pix.confirm_transfer': 'Confirmar transferência',
    // PixReceipt
    'pix.receipt_load_error': 'Erro ao carregar comprovante.',
    'pix.back_to_start': 'Voltar ao início',
    'pix.receipt_share_title': 'Comprovante de PIX - DogBank',
    'pix.receipt_share_text': 'Comprovante de PIX no valor de {amount} para {recipient}. ID: {id}',
    'pix.share_not_supported': 'Funcionalidade de compartilhamento não suportada neste navegador.',
    'pix.receipt_print_header': 'Comprovante de Transferência PIX',
    'pix.transfer_done': 'Transferência realizada!',
    'pix.pix_sent_success': 'O seu PIX foi enviado com sucesso.',
    'pix.type': 'Tipo',
    'pix.transaction_id': 'ID da transação',
    'pix.key_short': 'Chave',
    'pix.share_receipt': 'Compartilhar comprovante',
    'pix.print_receipt': 'Imprimir comprovante',
    'pix.finish': 'Concluir',
    // PixErrorModal
    'pix.err_timeout_title': 'Ops! Algo deu errado',
    'pix.err_timeout_subtitle': 'Estamos com dificuldades para processar sua transferência no momento.',
    'pix.err_timeout_desc': 'Não se preocupe, nada foi cobrado. Tente novamente em alguns instantes.',
    'pix.err_limit_title': 'Limite excedido',
    'pix.err_limit_subtitle': 'O valor ultrapassa o limite permitido para esta transação.',
    'pix.err_limit_desc': 'Tente um valor menor ou entre em contato com o suporte.',
    'pix.err_balance_subtitle': 'Você não possui saldo suficiente para esta transferência.',
    'pix.err_balance_desc': 'Confira seu saldo e tente novamente.',
    'pix.err_generic_title': 'Não foi possível completar o PIX',
    'pix.err_generic_subtitle': 'Algo inesperado aconteceu, mas nada foi cobrado.',
    'pix.err_generic_desc': 'Não se preocupe, confira seu saldo e tente novamente.',
    'pix.try_again': 'Tentar novamente',
    'pix.ok_understood': 'Ok, entendi',
    // PixTransferPage
    'pix.load_account_error_retry': 'Não foi possível carregar os dados da conta. Tente novamente mais tarde.',
    'pix.enter_valid_amount': 'Digite um valor válido e maior que zero',
    'pix.enter_key': 'Digite uma chave PIX',
    'pix.key_validation_error': 'Erro na validação da chave PIX',
    'pix.area_title': 'Área PIX',
    'pix.area_subtitle': 'Envie e receba dinheiro instantaneamente',
    'pix.send_to_whom': 'Para quem você quer enviar?',
    'pix.recommendations': 'Recomendações',
    'pix.placeholder_email': 'Digite o e-mail PIX',
    'pix.placeholder_cpf_phone': 'Digite o CPF ou telefone',
    'pix.placeholder_key': 'CPF, e-mail, telefone ou chave aleatória',
    'pix.validating_key': 'Validando chave PIX...',
    'pix.valid_key': 'Chave PIX válida',
    'pix.how_much': 'Quanto você quer enviar?',
    'pix.quick_amounts': 'Valores rápidos',
    'pix.description_placeholder': 'Ex: Pagamento do aluguel, presente, etc.',
    'pix.description_hint': 'Esta informação aparecerá no comprovante',
    // PixConfirmPage
    'pix.missing_data_title': 'Dados do PIX ausentes',
    'pix.missing_data_desc': 'Volte e inicie uma nova transferência.',
    'pix.back_to_pix': 'Voltar para PIX',
    'pix.confirm_pix': 'Confirmar PIX',
    'pix.confirm_subtitle': 'Revise os dados e confirme sua transferência',
    'pix.processing_pix': 'Processando seu PIX',
    'pix.processing_wait': 'Aguarde enquanto processamos sua transferência...',
    'pix.seconds': 'segundos',
    'pix.validating': 'Validando',
    'pix.processing_step': 'Processando',
    'pix.finalizing': 'Finalizando',
    'pix.transfer_summary': 'Resumo da transferência',
    'pix.to': 'Para',
    'pix.enter_password': 'Digite sua senha bancária',
    'pix.password_hint': 'Sua senha de 6 dígitos para confirmar a transferência',
    'pix.secure_transfer': 'Transferência segura',
    'pix.secure_transfer_desc': 'Seus dados estão protegidos e a transferência é irreversível após confirmação.',
    // PixReceiptPage
    'pix.receipt_not_found_msg': 'Recibo não encontrado.',
    'pix.share_text': 'Comprovante PIX DogBank\nValor: {amount}\nPara: {recipient}\nData: {date} às {time}\nCódigo: {code}',
    'pix.share_title': 'Comprovante PIX - DogBank',
    'pix.receipt_copied': 'Comprovante copiado para a área de transferência!',
    'pix.loading_receipt': 'Carregando comprovante...',
    'pix.receipt_not_found_title': 'Comprovante não encontrado',
    'pix.back_to_dashboard': 'Voltar ao Dashboard',
    'pix.sender': 'Remetente',
    'pix.pix_completed': 'PIX Concluído!',
    'pix.transfer_success_msg': 'Sua transferência foi realizada com sucesso',
    'pix.amount_transferred': 'Valor transferido',
    'pix.receipt_transfer_title': 'Comprovante de Transferência',
    'pix.transfer_amount': 'Valor da transferência',
    'pix.source_account': 'Conta Origem',
    'pix.from': 'De',
    'pix.document': 'Documento',
    'pix.agency': 'Agência',
    'pix.account': 'Conta',
    'pix.destination_account': 'Conta Destino',
    'pix.transfer_info': 'Informações da Transferência',
    'pix.auth_code': 'Código de Autenticação',
    'pix.transaction_id_full': 'ID da Transação',
    'pix.generated_at': 'Documento gerado em',
    'pix.make_another_pix': 'Fazer outro PIX',
    'pix.share': 'Compartilhar',
    'pix.print': 'Imprimir',
  },
  es: {
    'pix.transfer_pix': 'Transferencia PIX',
    'pix.available_balance': 'Saldo disponible',
    'pix.key_label': 'Clave PIX',
    'pix.recipient': 'Destinatario',
    'pix.bank': 'Banco',
    'pix.amount_label': 'Importe',
    'pix.description': 'Descripción',
    'pix.description_optional': 'Descripción (opcional)',
    'pix.date_time': 'Fecha y hora',
    'pix.processing': 'Procesando...',
    'pix.continue': 'Continuar',
    'pix.back': 'Volver',
    'pix.not_identified': 'No identificado',
    'pix.insufficient_balance': 'Saldo insuficiente',
    'pix.receipt': 'Comprobante',
    'pix.load_account_error': 'No fue posible cargar los datos de su cuenta.',
    'pix.enter_valid_key': 'Ingrese una clave PIX válida',
    'pix.invalid_key': 'Clave PIX inválida',
    'pix.validate_key_error': 'Error al validar la clave PIX.',
    'pix.invalid_amount': 'Importe inválido',
    'pix.transfer_success': '¡Transferencia realizada con éxito!',
    'pix.process_error': 'Error al procesar su transferencia.',
    'pix.validate_transaction_error': 'Error al validar la transacción PIX.',
    'pix.process_error_retry': 'Ocurrió un error al procesar su transferencia. Inténtelo de nuevo más tarde.',
    'pix.transfer_completed': 'Transferencia por PIX concluida',
    'pix.insufficient_data': 'Datos insuficientes para confirmar la transferencia.',
    'pix.back_to_form': 'Volver al formulario',
    'pix.confirm_transfer': 'Confirmar transferencia',
    'pix.receipt_load_error': 'Error al cargar el comprobante.',
    'pix.back_to_start': 'Volver al inicio',
    'pix.receipt_share_title': 'Comprobante de PIX - DogBank',
    'pix.receipt_share_text': 'Comprobante de PIX por el importe de {amount} para {recipient}. ID: {id}',
    'pix.share_not_supported': 'Función de compartir no compatible con este navegador.',
    'pix.receipt_print_header': 'Comprobante de Transferencia PIX',
    'pix.transfer_done': '¡Transferencia realizada!',
    'pix.pix_sent_success': 'Su PIX se envió con éxito.',
    'pix.type': 'Tipo',
    'pix.transaction_id': 'ID de la transacción',
    'pix.key_short': 'Clave',
    'pix.share_receipt': 'Compartir comprobante',
    'pix.print_receipt': 'Imprimir comprobante',
    'pix.finish': 'Concluir',
    'pix.err_timeout_title': '¡Ups! Algo salió mal',
    'pix.err_timeout_subtitle': 'Estamos teniendo dificultades para procesar su transferencia en este momento.',
    'pix.err_timeout_desc': 'No se preocupe, no se realizó ningún cargo. Inténtelo de nuevo en unos instantes.',
    'pix.err_limit_title': 'Límite excedido',
    'pix.err_limit_subtitle': 'El importe supera el límite permitido para esta transacción.',
    'pix.err_limit_desc': 'Intente con un importe menor o póngase en contacto con el soporte.',
    'pix.err_balance_subtitle': 'No tiene saldo suficiente para esta transferencia.',
    'pix.err_balance_desc': 'Verifique su saldo e inténtelo de nuevo.',
    'pix.err_generic_title': 'No fue posible completar el PIX',
    'pix.err_generic_subtitle': 'Ocurrió algo inesperado, pero no se realizó ningún cargo.',
    'pix.err_generic_desc': 'No se preocupe, verifique su saldo e inténtelo de nuevo.',
    'pix.try_again': 'Intentar de nuevo',
    'pix.ok_understood': 'Ok, entendido',
    'pix.load_account_error_retry': 'No fue posible cargar los datos de la cuenta. Inténtelo de nuevo más tarde.',
    'pix.enter_valid_amount': 'Ingrese un importe válido y mayor que cero',
    'pix.enter_key': 'Ingrese una clave PIX',
    'pix.key_validation_error': 'Error en la validación de la clave PIX',
    'pix.area_title': 'Área PIX',
    'pix.area_subtitle': 'Envíe y reciba dinero al instante',
    'pix.send_to_whom': '¿A quién quiere enviar?',
    'pix.recommendations': 'Recomendaciones',
    'pix.placeholder_email': 'Ingrese el correo electrónico PIX',
    'pix.placeholder_cpf_phone': 'Ingrese el CPF o teléfono',
    'pix.placeholder_key': 'CPF, correo electrónico, teléfono o clave aleatoria',
    'pix.validating_key': 'Validando clave PIX...',
    'pix.valid_key': 'Clave PIX válida',
    'pix.how_much': '¿Cuánto quiere enviar?',
    'pix.quick_amounts': 'Importes rápidos',
    'pix.description_placeholder': 'Ej.: Pago del alquiler, regalo, etc.',
    'pix.description_hint': 'Esta información aparecerá en el comprobante',
    'pix.missing_data_title': 'Faltan datos del PIX',
    'pix.missing_data_desc': 'Vuelva e inicie una nueva transferencia.',
    'pix.back_to_pix': 'Volver a PIX',
    'pix.confirm_pix': 'Confirmar PIX',
    'pix.confirm_subtitle': 'Revise los datos y confirme su transferencia',
    'pix.processing_pix': 'Procesando su PIX',
    'pix.processing_wait': 'Espere mientras procesamos su transferencia...',
    'pix.seconds': 'segundos',
    'pix.validating': 'Validando',
    'pix.processing_step': 'Procesando',
    'pix.finalizing': 'Finalizando',
    'pix.transfer_summary': 'Resumen de la transferencia',
    'pix.to': 'Para',
    'pix.enter_password': 'Ingrese su contraseña bancaria',
    'pix.password_hint': 'Su contraseña de 6 dígitos para confirmar la transferencia',
    'pix.secure_transfer': 'Transferencia segura',
    'pix.secure_transfer_desc': 'Sus datos están protegidos y la transferencia es irreversible tras la confirmación.',
    'pix.receipt_not_found_msg': 'Recibo no encontrado.',
    'pix.share_text': 'Comprobante PIX DogBank\nImporte: {amount}\nPara: {recipient}\nFecha: {date} a las {time}\nCódigo: {code}',
    'pix.share_title': 'Comprobante PIX - DogBank',
    'pix.receipt_copied': '¡Comprobante copiado al portapapeles!',
    'pix.loading_receipt': 'Cargando comprobante...',
    'pix.receipt_not_found_title': 'Comprobante no encontrado',
    'pix.back_to_dashboard': 'Volver al Panel',
    'pix.sender': 'Remitente',
    'pix.pix_completed': '¡PIX Concluido!',
    'pix.transfer_success_msg': 'Su transferencia se realizó con éxito',
    'pix.amount_transferred': 'Importe transferido',
    'pix.receipt_transfer_title': 'Comprobante de Transferencia',
    'pix.transfer_amount': 'Importe de la transferencia',
    'pix.source_account': 'Cuenta de Origen',
    'pix.from': 'De',
    'pix.document': 'Documento',
    'pix.agency': 'Agencia',
    'pix.account': 'Cuenta',
    'pix.destination_account': 'Cuenta de Destino',
    'pix.transfer_info': 'Información de la Transferencia',
    'pix.auth_code': 'Código de Autenticación',
    'pix.transaction_id_full': 'ID de la Transacción',
    'pix.generated_at': 'Documento generado el',
    'pix.make_another_pix': 'Hacer otro PIX',
    'pix.share': 'Compartir',
    'pix.print': 'Imprimir',
  },
  en: {
    'pix.transfer_pix': 'PIX Transfer',
    'pix.available_balance': 'Available balance',
    'pix.key_label': 'PIX key',
    'pix.recipient': 'Recipient',
    'pix.bank': 'Bank',
    'pix.amount_label': 'Amount',
    'pix.description': 'Description',
    'pix.description_optional': 'Description (optional)',
    'pix.date_time': 'Date and time',
    'pix.processing': 'Processing...',
    'pix.continue': 'Continue',
    'pix.back': 'Back',
    'pix.not_identified': 'Not identified',
    'pix.insufficient_balance': 'Insufficient balance',
    'pix.receipt': 'Receipt',
    'pix.load_account_error': 'We could not load your account data.',
    'pix.enter_valid_key': 'Enter a valid PIX key',
    'pix.invalid_key': 'Invalid PIX key',
    'pix.validate_key_error': 'Error validating the PIX key.',
    'pix.invalid_amount': 'Invalid amount',
    'pix.transfer_success': 'Transfer completed successfully!',
    'pix.process_error': 'Error processing your transfer.',
    'pix.validate_transaction_error': 'Error validating the PIX transaction.',
    'pix.process_error_retry': 'An error occurred while processing your transfer. Please try again later.',
    'pix.transfer_completed': 'PIX transfer completed',
    'pix.insufficient_data': 'Insufficient data to confirm the transfer.',
    'pix.back_to_form': 'Back to form',
    'pix.confirm_transfer': 'Confirm transfer',
    'pix.receipt_load_error': 'Error loading receipt.',
    'pix.back_to_start': 'Back to start',
    'pix.receipt_share_title': 'PIX Receipt - DogBank',
    'pix.receipt_share_text': 'PIX receipt in the amount of {amount} to {recipient}. ID: {id}',
    'pix.share_not_supported': 'Sharing is not supported in this browser.',
    'pix.receipt_print_header': 'PIX Transfer Receipt',
    'pix.transfer_done': 'Transfer completed!',
    'pix.pix_sent_success': 'Your PIX was sent successfully.',
    'pix.type': 'Type',
    'pix.transaction_id': 'Transaction ID',
    'pix.key_short': 'Key',
    'pix.share_receipt': 'Share receipt',
    'pix.print_receipt': 'Print receipt',
    'pix.finish': 'Finish',
    'pix.err_timeout_title': 'Oops! Something went wrong',
    'pix.err_timeout_subtitle': 'We are having trouble processing your transfer right now.',
    'pix.err_timeout_desc': 'Don\'t worry, nothing was charged. Please try again in a few moments.',
    'pix.err_limit_title': 'Limit exceeded',
    'pix.err_limit_subtitle': 'The amount exceeds the limit allowed for this transaction.',
    'pix.err_limit_desc': 'Try a smaller amount or contact support.',
    'pix.err_balance_subtitle': 'You do not have enough balance for this transfer.',
    'pix.err_balance_desc': 'Check your balance and try again.',
    'pix.err_generic_title': 'Could not complete the PIX',
    'pix.err_generic_subtitle': 'Something unexpected happened, but nothing was charged.',
    'pix.err_generic_desc': 'Don\'t worry, check your balance and try again.',
    'pix.try_again': 'Try again',
    'pix.ok_understood': 'OK, got it',
    'pix.load_account_error_retry': 'We could not load the account data. Please try again later.',
    'pix.enter_valid_amount': 'Enter a valid amount greater than zero',
    'pix.enter_key': 'Enter a PIX key',
    'pix.key_validation_error': 'Error validating the PIX key',
    'pix.area_title': 'PIX Area',
    'pix.area_subtitle': 'Send and receive money instantly',
    'pix.send_to_whom': 'Who do you want to send to?',
    'pix.recommendations': 'Recommendations',
    'pix.placeholder_email': 'Enter the PIX email',
    'pix.placeholder_cpf_phone': 'Enter the CPF or phone number',
    'pix.placeholder_key': 'CPF, email, phone or random key',
    'pix.validating_key': 'Validating PIX key...',
    'pix.valid_key': 'Valid PIX key',
    'pix.how_much': 'How much do you want to send?',
    'pix.quick_amounts': 'Quick amounts',
    'pix.description_placeholder': 'E.g.: Rent payment, gift, etc.',
    'pix.description_hint': 'This information will appear on the receipt',
    'pix.missing_data_title': 'PIX data missing',
    'pix.missing_data_desc': 'Go back and start a new transfer.',
    'pix.back_to_pix': 'Back to PIX',
    'pix.confirm_pix': 'Confirm PIX',
    'pix.confirm_subtitle': 'Review the details and confirm your transfer',
    'pix.processing_pix': 'Processing your PIX',
    'pix.processing_wait': 'Please wait while we process your transfer...',
    'pix.seconds': 'seconds',
    'pix.validating': 'Validating',
    'pix.processing_step': 'Processing',
    'pix.finalizing': 'Finalizing',
    'pix.transfer_summary': 'Transfer summary',
    'pix.to': 'To',
    'pix.enter_password': 'Enter your banking password',
    'pix.password_hint': 'Your 6-digit password to confirm the transfer',
    'pix.secure_transfer': 'Secure transfer',
    'pix.secure_transfer_desc': 'Your data is protected and the transfer is irreversible after confirmation.',
    'pix.receipt_not_found_msg': 'Receipt not found.',
    'pix.share_text': 'PIX Receipt DogBank\nAmount: {amount}\nTo: {recipient}\nDate: {date} at {time}\nCode: {code}',
    'pix.share_title': 'PIX Receipt - DogBank',
    'pix.receipt_copied': 'Receipt copied to clipboard!',
    'pix.loading_receipt': 'Loading receipt...',
    'pix.receipt_not_found_title': 'Receipt not found',
    'pix.back_to_dashboard': 'Back to Dashboard',
    'pix.sender': 'Sender',
    'pix.pix_completed': 'PIX Completed!',
    'pix.transfer_success_msg': 'Your transfer was completed successfully',
    'pix.amount_transferred': 'Amount transferred',
    'pix.receipt_transfer_title': 'Transfer Receipt',
    'pix.transfer_amount': 'Transfer amount',
    'pix.source_account': 'Source Account',
    'pix.from': 'From',
    'pix.document': 'Document',
    'pix.agency': 'Branch',
    'pix.account': 'Account',
    'pix.destination_account': 'Destination Account',
    'pix.transfer_info': 'Transfer Information',
    'pix.auth_code': 'Authentication Code',
    'pix.transaction_id_full': 'Transaction ID',
    'pix.generated_at': 'Document generated on',
    'pix.make_another_pix': 'Make another PIX',
    'pix.share': 'Share',
    'pix.print': 'Print',
  },
  it: {
    'pix.transfer_pix': 'Bonifico PIX',
    'pix.available_balance': 'Saldo disponibile',
    'pix.key_label': 'Chiave PIX',
    'pix.recipient': 'Destinatario',
    'pix.bank': 'Banca',
    'pix.amount_label': 'Importo',
    'pix.description': 'Descrizione',
    'pix.description_optional': 'Descrizione (facoltativa)',
    'pix.date_time': 'Data e ora',
    'pix.processing': 'Elaborazione...',
    'pix.continue': 'Continua',
    'pix.back': 'Indietro',
    'pix.not_identified': 'Non identificato',
    'pix.insufficient_balance': 'Saldo insufficiente',
    'pix.receipt': 'Ricevuta',
    'pix.load_account_error': 'Non è stato possibile caricare i dati del tuo conto.',
    'pix.enter_valid_key': 'Inserisci una chiave PIX valida',
    'pix.invalid_key': 'Chiave PIX non valida',
    'pix.validate_key_error': 'Errore durante la convalida della chiave PIX.',
    'pix.invalid_amount': 'Importo non valido',
    'pix.transfer_success': 'Bonifico effettuato con successo!',
    'pix.process_error': 'Errore durante l\'elaborazione del bonifico.',
    'pix.validate_transaction_error': 'Errore durante la convalida della transazione PIX.',
    'pix.process_error_retry': 'Si è verificato un errore durante l\'elaborazione del bonifico. Riprova più tardi.',
    'pix.transfer_completed': 'Bonifico tramite PIX completato',
    'pix.insufficient_data': 'Dati insufficienti per confermare il bonifico.',
    'pix.back_to_form': 'Torna al modulo',
    'pix.confirm_transfer': 'Conferma bonifico',
    'pix.receipt_load_error': 'Errore durante il caricamento della ricevuta.',
    'pix.back_to_start': 'Torna all\'inizio',
    'pix.receipt_share_title': 'Ricevuta PIX - DogBank',
    'pix.receipt_share_text': 'Ricevuta PIX dell\'importo di {amount} a {recipient}. ID: {id}',
    'pix.share_not_supported': 'Funzione di condivisione non supportata in questo browser.',
    'pix.receipt_print_header': 'Ricevuta di Bonifico PIX',
    'pix.transfer_done': 'Bonifico effettuato!',
    'pix.pix_sent_success': 'Il tuo PIX è stato inviato con successo.',
    'pix.type': 'Tipo',
    'pix.transaction_id': 'ID della transazione',
    'pix.key_short': 'Chiave',
    'pix.share_receipt': 'Condividi ricevuta',
    'pix.print_receipt': 'Stampa ricevuta',
    'pix.finish': 'Concludi',
    'pix.err_timeout_title': 'Ops! Qualcosa è andato storto',
    'pix.err_timeout_subtitle': 'Al momento abbiamo difficoltà a elaborare il tuo bonifico.',
    'pix.err_timeout_desc': 'Non preoccuparti, non è stato addebitato nulla. Riprova tra qualche istante.',
    'pix.err_limit_title': 'Limite superato',
    'pix.err_limit_subtitle': 'L\'importo supera il limite consentito per questa transazione.',
    'pix.err_limit_desc': 'Prova con un importo inferiore o contatta l\'assistenza.',
    'pix.err_balance_subtitle': 'Non hai saldo sufficiente per questo bonifico.',
    'pix.err_balance_desc': 'Controlla il saldo e riprova.',
    'pix.err_generic_title': 'Impossibile completare il PIX',
    'pix.err_generic_subtitle': 'Si è verificato un imprevisto, ma non è stato addebitato nulla.',
    'pix.err_generic_desc': 'Non preoccuparti, controlla il saldo e riprova.',
    'pix.try_again': 'Riprova',
    'pix.ok_understood': 'Ok, ho capito',
    'pix.load_account_error_retry': 'Non è stato possibile caricare i dati del conto. Riprova più tardi.',
    'pix.enter_valid_amount': 'Inserisci un importo valido e maggiore di zero',
    'pix.enter_key': 'Inserisci una chiave PIX',
    'pix.key_validation_error': 'Errore nella convalida della chiave PIX',
    'pix.area_title': 'Area PIX',
    'pix.area_subtitle': 'Invia e ricevi denaro istantaneamente',
    'pix.send_to_whom': 'A chi vuoi inviare?',
    'pix.recommendations': 'Consigliati',
    'pix.placeholder_email': 'Inserisci l\'e-mail PIX',
    'pix.placeholder_cpf_phone': 'Inserisci il CPF o il telefono',
    'pix.placeholder_key': 'CPF, e-mail, telefono o chiave casuale',
    'pix.validating_key': 'Convalida chiave PIX...',
    'pix.valid_key': 'Chiave PIX valida',
    'pix.how_much': 'Quanto vuoi inviare?',
    'pix.quick_amounts': 'Importi rapidi',
    'pix.description_placeholder': 'Es.: Pagamento dell\'affitto, regalo, ecc.',
    'pix.description_hint': 'Questa informazione apparirà sulla ricevuta',
    'pix.missing_data_title': 'Dati PIX mancanti',
    'pix.missing_data_desc': 'Torna indietro e avvia un nuovo bonifico.',
    'pix.back_to_pix': 'Torna a PIX',
    'pix.confirm_pix': 'Conferma PIX',
    'pix.confirm_subtitle': 'Controlla i dati e conferma il tuo bonifico',
    'pix.processing_pix': 'Elaborazione del tuo PIX',
    'pix.processing_wait': 'Attendi mentre elaboriamo il tuo bonifico...',
    'pix.seconds': 'secondi',
    'pix.validating': 'Convalida',
    'pix.processing_step': 'Elaborazione',
    'pix.finalizing': 'Completamento',
    'pix.transfer_summary': 'Riepilogo del bonifico',
    'pix.to': 'A',
    'pix.enter_password': 'Inserisci la tua password bancaria',
    'pix.password_hint': 'La tua password di 6 cifre per confermare il bonifico',
    'pix.secure_transfer': 'Bonifico sicuro',
    'pix.secure_transfer_desc': 'I tuoi dati sono protetti e il bonifico è irreversibile dopo la conferma.',
    'pix.receipt_not_found_msg': 'Ricevuta non trovata.',
    'pix.share_text': 'Ricevuta PIX DogBank\nImporto: {amount}\nA: {recipient}\nData: {date} alle {time}\nCodice: {code}',
    'pix.share_title': 'Ricevuta PIX - DogBank',
    'pix.receipt_copied': 'Ricevuta copiata negli appunti!',
    'pix.loading_receipt': 'Caricamento ricevuta...',
    'pix.receipt_not_found_title': 'Ricevuta non trovata',
    'pix.back_to_dashboard': 'Torna alla Dashboard',
    'pix.sender': 'Mittente',
    'pix.pix_completed': 'PIX Completato!',
    'pix.transfer_success_msg': 'Il tuo bonifico è stato effettuato con successo',
    'pix.amount_transferred': 'Importo trasferito',
    'pix.receipt_transfer_title': 'Ricevuta di Bonifico',
    'pix.transfer_amount': 'Importo del bonifico',
    'pix.source_account': 'Conto di Origine',
    'pix.from': 'Da',
    'pix.document': 'Documento',
    'pix.agency': 'Filiale',
    'pix.account': 'Conto',
    'pix.destination_account': 'Conto di Destinazione',
    'pix.transfer_info': 'Informazioni sul Bonifico',
    'pix.auth_code': 'Codice di Autenticazione',
    'pix.transaction_id_full': 'ID della Transazione',
    'pix.generated_at': 'Documento generato il',
    'pix.make_another_pix': 'Fai un altro PIX',
    'pix.share': 'Condividi',
    'pix.print': 'Stampa',
  },
};

export default pix;
